import axios from 'axios';

import { getAPIUrl } from './baseAPI';
import { FeatureFlag, FeatureFlagBody } from 'types/domainModels';

export const FETCH_FEATURE_FLAGS = () => ({
  path: '/featureFlags',
  version: 'v2' as const,
});

export async function fetchFeatureFlags() {
  return (await axios.get<FeatureFlag[]>(getAPIUrl(FETCH_FEATURE_FLAGS())))
    .data;
}

export const FETCH_FEATURE_FLAG = ({
  featureFlagId,
}: {
  featureFlagId: number;
}) => ({
  path: `/featureFlags/${featureFlagId}`,
  version: 'v2' as const,
});

export async function fetchFeatureFlag({
  featureFlagId,
}: {
  featureFlagId: number;
}) {
  return (
    await axios.get<FeatureFlag>(
      getAPIUrl(FETCH_FEATURE_FLAG({ featureFlagId })),
    )
  ).data;
}

export const CREATE_FEATURE_FLAG = () => ({
  path: '/featureFlags',
  version: 'v2' as const,
});

export async function createFeatureFlag({ data }: { data: FeatureFlagBody }) {
  return (await axios.post<FeatureFlag>(getAPIUrl(CREATE_FEATURE_FLAG()), data))
    .data;
}

export const UPDATE_FEATURE_FLAG = ({
  featureFlagId,
}: {
  featureFlagId: number;
}) => ({
  path: `/featureFlags/${featureFlagId}`,
  version: 'v2' as const,
});

export async function updateFeatureFlag({
  featureFlagId,
  data,
}: {
  featureFlagId: number;
  data: Partial<FeatureFlagBody>;
}) {
  return (
    await axios.patch<FeatureFlag>(
      getAPIUrl(UPDATE_FEATURE_FLAG({ featureFlagId })),
      data,
    )
  ).data;
}

export const DELETE_FEATURE_FLAG = ({
  featureFlagId,
}: {
  featureFlagId: number;
}) => ({
  path: `/featureFlags/${featureFlagId}`,
  version: 'v2' as const,
});

export async function deleteFeatureFlag({
  featureFlagId,
}: {
  featureFlagId: number;
}) {
  await axios.delete<void>(getAPIUrl(DELETE_FEATURE_FLAG({ featureFlagId })));
}
